import { ToastVariant } from '@freighthub/silhouette-core'
import { action, observable } from 'mobx'

export class NotificationToastService {
  @observable
  isOpen: boolean = false
  @observable
  message: string = ''
  @observable
  variant: ToastVariant = 'info'

  add = (type: ToastVariant, message: string) => {
    this.setter(type, message)
  }

  hide = () => {
    this.reset()
  }

  @action
  private reset = () => {
    this.isOpen = false
  }

  @action
  private setter(variant: ToastVariant, message: string) {
    this.isOpen = true
    this.variant = variant
    this.message = message
  }
}
